import React from "react";
import "@/App.css";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ProfileSection from "@/components/ProfileSection";
import ExperienceSection from "@/components/ExperienceSection";
import PipelineSection from "@/components/PipelineSection";
import ToolkitSection from "@/components/ToolkitSection";
// WorkAreasSection removed
import DeliverablesSection from "@/components/DeliverablesSection";
import ContactSection from "@/components/ContactSection";
import FooterSection from "@/components/FooterSection";

const BG_VIDEO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_build-web-605/artifacts/nkxb63z7_IMG_3313.MP4";

function App() {
  return (
    <div className="min-h-screen text-white relative">
      {/* Fixed full-page background video */}
      <div className="fixed inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          className="w-full h-full object-cover"
          data-testid="background-video"
        >
          <source src={BG_VIDEO} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content on top of video */}
      <div className="relative z-10">
        <Navigation />
        <HeroSection />
        <ProfileSection />
        <ExperienceSection />
        <PipelineSection />
        <ToolkitSection />
        <DeliverablesSection />
        <ContactSection />
        <FooterSection />
      </div>
    </div>
  );
}

export default App;
